import type { Image } from '@ps/web-martech-cms-types';
import type { ClassNameProp } from '@ps/web-shared-components';
import { isNull } from 'lodash';
import React from 'react';

import useAuthenticatedContent from '../../hooks/useAuthenticatedContent';
import CMSPreloadImage from '../CMSPreloadImage/CMSPreloadImage';

import styles from './CMSImage.scss';

type Props = Partial<Image> &
  Partial<ClassNameProp> & {
    onClick?(e: React.MouseEvent<HTMLImageElement, MouseEvent>): void;
  };

const CMSImage: React.FC<Props> = ({
  className,
  onClick,
  logged_in_image: loggedInImage,
  ...image
}) => {
  const { alt, asset, width, height } = useAuthenticatedContent<Omit<Image, 'logged_in_image'>>(
    image,
    loggedInImage
  );

  if (asset) {
    const dimensions = {
      width: isNull(width) ? undefined : width,
      height: isNull(height) ? undefined : height
    };

    return (
      <>
        <CMSPreloadImage imageUrl={asset.url} />
        <img
          alt={alt}
          src={asset.url}
          {...dimensions}
          onClick={(e) => onClick?.(e)}
          className={className ? className : styles.image}
        />
      </>
    );
  }

  return null;
};

export default CMSImage;
